import React, { useId } from "react";
import { FlashbarProps } from "@cloudscape-design/components/flashbar";

//todo just added temporary flash need to work on it - I need to understand type of error from API's to design and build this component
//After implementing add unit tests for this and remove from test coverage exclude list in vite.config.ts file
export function useDisclaimerFlashbarItem(
  onDismiss: (id: string) => void
): FlashbarProps.MessageDefinition | null {
  const id = useId();

  return {
    type: "info",
    dismissible: true,
    dismissLabel: "Dismiss message",
    onDismiss: () => onDismiss(id),
    statusIconAriaLabel: "info",
    content: (
      <>
        This demo is an example of Cloudscape Design System patterns and
        components, and may not reflect the current patterns and components of
        AWS services.
      </>
    ),
    id,
  };
}
